import {connect} from 'react-redux';
import FeesList from './FeesList.jsx'; 
import {handleDefaultTechFeeEditClick} from './actions';

const mapStateToProps = state => ({ 
    feeData: state.finance.fees.feesList
});

const mapDispatchToProps = dispatch => ({ 
    onEditDefaultTechFeeClick: () => dispatch(handleDefaultTechFeeEditClick())
});

export default connect(mapStateToProps, mapDispatchToProps)(FeesList);



// WEBPACK FOOTER //
// ./src/features/finance/fees/FeesListContainer.jsx